'use client';

import { VolumeForm } from '@prismo-io/feature-organization/forms/volume';
import { type ComponentProps, type FC, useCallback } from 'react';
import { useSetOrganizationMetadata } from './use-set-organization-metadata';

type FormProps = ComponentProps<typeof VolumeForm>;

type Props = Omit<FormProps, 'onSubmit'>;

export const VolumeFormWrapper: FC<Props> = (props) => {
  const { trigger: setMetadata } = useSetOrganizationMetadata();

  const onSubmit: FormProps['onSubmit'] = useCallback(
    (data) => {
      setMetadata(data);
    },
    [setMetadata]
  );

  return <VolumeForm {...props} onSubmit={onSubmit} />;
};
